import React from 'react';
import { RuleSet } from 'styled-components';
import { DirectionEnum } from '../types';
import { SliderButton, SliderButtonsContainer } from './styled';

interface SliderButtonsProps {
  isLeftButtonDisabled: boolean;
  isRightButtonDisabled: boolean;
  styles?: RuleSet<object>;
  onLeftButtonClick: () => void;
  onRightButtonClick: () => void;
}

export const SliderButtons: React.FC<SliderButtonsProps> = ({
  isLeftButtonDisabled,
  isRightButtonDisabled,
  styles,
  onLeftButtonClick,
  onRightButtonClick
}) => (
  <SliderButtonsContainer $styles={styles}>
    <SliderButton
      onClick={onLeftButtonClick}
      disabled={isLeftButtonDisabled}
      $direction={DirectionEnum.left}
      data-cy="slider-left-arrow-button"
      aria-label="Slide left"
    />
    <SliderButton
      onClick={onRightButtonClick}
      disabled={isRightButtonDisabled}
      $direction={DirectionEnum.right}
      data-cy="slider-right-arrow-button"
      aria-label="Slide Right"
    />
  </SliderButtonsContainer>
);
